// extracted by mini-css-extract-plugin
export default {"keyboard-shortcuts":"g__keyboard-shortcuts--sui8T","section":"g__section--JlWLT","separator":"g__separator--gd7i9","category":"g__category--Q0jRI"};